import type { ComponentType } from 'react';
import React from 'react';
import { useStyletron } from 'baseui';
import { ParagraphXSmall } from 'baseui/typography';
export type SearchOptionWithIcon = {
  label: string;
  value: string;
  strokeColor?: string;
  renderIcon?: ComponentType<{
    strokeColor: string;
  }>;
};
export const RenderSearchOptionLabel = (option: SearchOptionWithIcon) => {
  const {
    renderIcon: RenderIcon,
    strokeColor,
    label
  } = option;
  const [, theme] = useStyletron();
  return <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: theme.sizing.scale300
  }}>
      {RenderIcon && strokeColor && <RenderIcon strokeColor={strokeColor} />}
      <ParagraphXSmall margin={0}>{label}</ParagraphXSmall>
    </div>;
};